// O Chrome acende :focus-visible depois de QUALQUER tecla (ESC, atalhos) no
// elemento que ganhou foco por clique. O anel de foco do app só deve aparecer
// quando o usuário está navegando pelo teclado; esta flag em <html> separa os dois.
const KEYBOARD_NAVIGATION_KEYS = new Set([
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Home",
  "End",
  "PageUp",
  "PageDown",
]);

export function installFocusModality(doc = document) {
  const root = doc && doc.documentElement;
  if (!root || root.dataset.focusModalityInstalled === "1") return () => {};

  root.dataset.focusModalityInstalled = "1";
  root.dataset.focusSource = "pointer";

  const onKeyDown = (event) => {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    if (KEYBOARD_NAVIGATION_KEYS.has(event.key)) root.dataset.focusSource = "keyboard";
  };
  const onPointerDown = () => {
    root.dataset.focusSource = "pointer";
  };

  doc.addEventListener("keydown", onKeyDown, true);
  doc.addEventListener("pointerdown", onPointerDown, true);
  doc.addEventListener("mousedown", onPointerDown, true);

  return () => {
    doc.removeEventListener("keydown", onKeyDown, true);
    doc.removeEventListener("pointerdown", onPointerDown, true);
    doc.removeEventListener("mousedown", onPointerDown, true);
    delete root.dataset.focusModalityInstalled;
    delete root.dataset.focusSource;
  };
}
